<template>
  <div class="ai-header">
    <div class="header-left">
      <div v-if="!monitor" class="action-btn" @click="handleFullScreen">
        <div v-if="fullscreen" class="btn-content">
          <i class="el-icon-aim"></i>
          <span style="color:white;">退出全屏</span>
        </div>
        <div v-else class="btn-content">
          <i style="color:white;" class="el-icon-full-screen"></i>
          <span style="color:white;">全屏</span>
        </div>
      </div>
    </div>

    <div class="title">
      {{
        analysis
          ? "优食安菜品营养成分分析"
          : dianzhang
          ? "店长助手每日自检任务清单"
          : monitor
          ? "优食安视频监控大屏"
          : outer || base
          ? "优食安数字食堂云平台"
          : prevention
          ? "优食安防鼠专项工作展示大屏"
          : storage
          ? "优柿供应链智慧大屏系统"
          : Hai
          ? "优食安AI健康监测管理"
          : "优食安数字食堂内控管理大屏"
      }}
    </div>

    <div class="header-right">
      <div v-if="outer || inner || base" class="action-btn shortcut-btn" @click="showDialog">
        <i class="el-icon-s-unfold"></i>
        <span style="color:white;">快捷导航</span>
      </div>

      <div v-if="prevention || AiHeaderQuery || analysis" class="action-btn" @click="back">
        <img src="../assets/image/fanhui.png" alt="返回" class="btn-icon" />
        <span style="color:white;">返回</span>
      </div>
      
      <div v-else class="action-btn" @click="out">
        <span style="color:white;">退出</span>
        <img src="../assets/image/tuichu2.png" alt="退出" class="btn-icon right-icon" />
      </div>
    </div>

    <el-dialog
      title="快捷导航"
      :visible.sync="dialogVisible"
      width="60%"
      :modal="false"
      custom-class="light-dialog"
    >
      <div class="dialog-content">
        <div
          class="dialogItem"
          @click="toOtherPage(item.url)"
          v-for="(item, index) in navList"
          :key="index"
        >
          <div
            class="dialogItemImg"
            :style="{ backgroundColor: backObj[item.name] }"
          >
            <img :src="item.img" alt="" style="width: 45px; height: 45px" />
          </div>
          <div class="dialog-text">{{ item.name }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { myMixin } from "../common/common.js";

export default {
  mixins: [myMixin],
  props: {
    outer: { type: Boolean, default: false },
    Hai: { type: Boolean, default: false },
    base: { type: Boolean, default: false },
    inner: { type: Boolean, default: false },
    monitor: { type: Boolean, default: false },
    prevention: { type: Boolean, default: false },
    AiHeaderQuery: { type: Boolean, default: false },
    storage: { type: Boolean, default: false },
    dianzhang: { type: Boolean, default: false },
    analysis: { type: Boolean, default: false },
  },
  data() {
    return {
      fullscreen: false,
      dialogVisible: false,
      backObj: {
        防鼠大屏: "#ffcc33",
        明厨亮灶监控大屏: "#ff9966",
        店长助手大屏: "#ff6666",
        物联网监控大屏: "#cc6600",
        内控管理大屏: "#339933",
        餐厅大屏: "#339933",
        健康证展示: "#0099cc",
        产品溯源大屏: "#99cc33",
        "产品溯源大屏-ERP版": "#cccc44",
        基础版大屏: "#666699",
        整改记录大屏: "#ffcc99",
        敬请期待: "#999999",
      },
      navList: null,
      spinning: false,
    };
  },
  mounted() {
    this.navList = JSON.parse(sessionStorage.getItem("navList"));
  },
  methods: {
    refresh() {
      this.spinning = true;
      this.$emit("childEvent");
      setTimeout(() => {
        this.spinning = false;
      }, 1000);
    },
    showDialog() {
      this.dialogVisible = true;
    },
    toOtherPage(url) {
      if (url) {
        this.$router.push({
          path: url,
          query: { from: "aiHeader" },
        });
      }
      this.dialogVisible = false;
    },
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if (document.msExitFullscreen) document.msExitFullscreen();
      } else {
        if (element.requestFullscreen) element.requestFullscreen();
        else if (element.webkitRequestFullScreen) element.webkitRequestFullScreen();
        else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
        else if (element.msRequestFullscreen) element.msRequestFullscreen();
      }
      this.fullscreen = !this.fullscreen;
    },
    out() {
      localStorage.clear();
      sessionStorage.clear();
      const v = Math.floor(Math.random() * 901) + 100;
      this.$router.push({ path: "login", query: { v } });
    },
    back() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
/* =======================================
   浅色现代化头部样式重构
======================================= */
.ai-header {
  width: 100%;
  height: 80px; /* 给出固定高度，不再用百分比导致挤压 */
  background: linear-gradient(135deg, #FE3B04 40%, #FE9D81 100%);
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05); /* 底部微小阴影分割内容 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-sizing: border-box;
  position: relative;
  z-index: 100;
}

/* --- 左侧与右侧按钮容器 --- */
.header-left, .header-right {
  display: flex;
  align-items: center;
  min-width: 200px; /* 保证两侧占位一致，让中间标题绝对居中 */
}
.header-right {
  justify-content: flex-end;
  gap: 20px; /* 按钮之间的间距 */
}

/* --- 交互按钮通用样式 --- */
.action-btn {
  display: flex;
  align-items: center;
  color: #666; /* 默认深灰色 */
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 5px 10px;
  border-radius: 6px;

  .btn-content {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  i {
    font-size: 20px;
  }
  
  span {
    font-weight: 500;
  }

  .btn-icon {
    width: 22px;
    height: 22px;
    margin-right: 6px;
    transition: all 0.3s ease;
  }
  .right-icon {
    margin-right: 0;
    margin-left: 6px;
  }

  /* 悬浮交互：变为主色调 #FE3B04 */
  &:hover {
    color: #FE3B04;
    background-color: rgba(254, 59, 4, 0.05); /* 微弱的橙色背景底 */
    
    .btn-icon {
      /* 悬浮时尝试给图标上色（利用滤镜），或者直接去掉滤镜让它变亮 */
      filter: invert(33%) sepia(87%) saturate(3015%) hue-rotate(345deg) brightness(99%) contrast(105%);
    }
  }
}

.shortcut-btn {
  i { margin-right: 6px; }
}

/* --- 中间大屏标题 --- */
.title {
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 2px;
  /* 使用主色调的高级渐变填充文字 */
  background: linear-gradient(to right, #FE3B04, #ff7a45);
  -webkit-background-clip: text;
  color: #fff;
  text-shadow: 0 2px 4px rgba(254, 59, 4, 0.1); /* 微弱的橙色发光 */
}

/* --- 弹窗内容样式 --- */
.dialog-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 20px 0;
}

.dialogItem {
  display: flex;
  flex-direction: column;
  width: 25%;
  align-items: center;
  margin-bottom: 40px;
  cursor: pointer;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px); /* 悬浮稍微上浮 */
    .dialog-text {
      color: #FE3B04;
    }
  }

  .dialogItemImg {
    width: 70px;
    height: 70px;
    border-radius: 20px; /* 改为现代的圆角矩形，比正圆更好看 */
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  }

  .dialog-text {
    font-size: 16px;
    color: #333; /* 弹窗内文字改深色 */
    font-weight: bold;
    transition: color 0.3s;
  }
}

/* --- 深度覆盖 Element UI 弹窗样式 (强制白底) --- */
::v-deep .light-dialog {
  background-color: #ffffff !important;
  border-radius: 12px;
  
  .el-dialog__header {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 15px;
  }
  
  .el-dialog__title {
    color: #333 !important;
    font-size: 20px;
    font-weight: bolder;
  }
  
  .el-dialog__headerbtn .el-dialog__close {
    color: #999 !important;
    font-size: 24px;
    &:hover { color: #FE3B04 !important; }
  }
}
</style>